/**
 * External dependencies
 */
import React from 'react';

/**
 * Style dependencies
 */
import './styles.scss';

const PlanCard = ({ name, description }) => (
    <div className='plan-card'>
        <div className='plan-card__body'>
            <div className='plan-card__name'>{name}</div>
            {description && <div className='plan-card__description'>{description}</div>}
        </div>
        <div className='plan-card__footer'>
            <span className='plan-card__cta'>Get started &rarr;</span>
        </div>
    </div>
);

export default PlanCard;
